<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <template v-if="!examStart && data && data.baseData">
      <div class="infoRect">
        <van-row>
          <van-col span="12">
            <!-- <i class="iconfont iconbi" /> --> {{ data.baseData.totalNum }}题
          </van-col>
          <van-col span="12" class="rigth"> <!--<i class="iconfont iconshijian" /> -->{{ data.baseData.timeMinute }}min</van-col>
        </van-row>
      </div>
      <div class="examStartRect">
        <div class="title">{{ data.baseData.title }}</div>
        <div class="about" v-html="data.baseData.about" />
        <div class="buttons">
          <van-button class="button" type="primary" round size="small" style="width:100%;" :disabled="!data.baseData.examResultId&&( !selectStudent || !selectStudent.isCanExam)" :loading="buttonLoading" :color="GetDiveMainBack()" @click="onStart">
            {{ data.baseData.examResultId?'继续未完成测验':'开始' }}
          </van-button>
          <van-radio-group v-if="!data.baseData.examResultId && data.baseData.examStudentInfo.length>1" v-model="studentId" :checked-color="GetDiveMainBack()" class="selectStudentRect" @change="onSelectStudent">
            <van-radio v-for="item in data.baseData.examStudentInfo" :key="item.studentId" :name="item.studentId" class="line">{{ item.className }} {{ item.lastName }} {{ item.firstName }}</van-radio>
          </van-radio-group>

          <div v-if="selectStudent && !selectStudent.isCanExam" class="cantabout">您已经参加过本次测验，不能重复参加，如需帮助请联系<b>{{ data.baseData.coachName }}</b>或客服。</div>
          <div v-if="data.baseData.examResultId" class="buttonMore">
            测验剩余时间:<van-count-down
              style=" display: inline-block;color:#999;"
              :time="data.baseData.examFinishTime"
              :format="data.baseData.examFinishTime > 3600000?'HH时mm分ss秒':'mm分ss秒'"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="examStart && data && data.baseData">
      <div class="infoRect">
        <van-row>
          <van-col span="12">
            <!-- <i class="iconfont iconbi" /> -->{{ questionIndex+1 }}/{{ data.baseData.totalNum }}
            <van-loading v-if="autoSaveing===true" style=" display: inline-block;" size="20" type="spinner" />
            <van-tag v-if="autoSaveing===false" plain :color="GetDiveMainBack()">已保存</van-tag>
          </van-col>
          <van-col span="12" class="rigth"><!-- <i class="iconfont iconshijian" />-->
            <van-count-down
              style="display: inline-block;color:#999;"
              :time="data.baseData.examFinishTime"
              :format="data.baseData.examFinishTime>3600000?'HH时mm分ss秒':'mm分ss秒'"
            />
          </van-col>
        </van-row>
      </div>
      <div class="questionRect">
        <div v-html="questionData.isMultiple?'<b>[多选]</b> '+questionData.question:questionData.question" />
      </div>

      <div class="answerRect">
        <van-radio-group v-if="!questionData.isMultiple" v-model="questionSelect" :checked-color="GetDiveMainBack()" @change="onquestionSelectChange">
          <van-radio v-for="answer in questionData.answer" :key="answer.answerId" :name="answer.answerId" class="answer">{{ answer.body }}</van-radio>
        </van-radio-group>
        <van-checkbox-group v-if="questionData.isMultiple" v-model="questionSelect" :checked-color="GetDiveMainBack()" @change="onquestionSelectChange">
          <van-checkbox v-for="answer in questionData.answer" :key="answer.answerId" :name="answer.answerId" class="answer">{{ answer.body }}</van-checkbox>
        </van-checkbox-group>
      </div>
      <div v-if="questionData.analysis" class="analysisRect"><b>题目解析:</b>{{ questionData.analysis }}</div>
      <div class="emptyRect" />
      <div class="buttonRect">
        <div class="buttons">
          <van-button :loading="buttonLoading" class="button" type="primary" square size="small" style="width:33%;" :disabled="questionIndex<=0" :color="GetDiveMainBack()" @click="onUpQuestion">上一题</van-button>
          <van-button :loading="buttonLoading" class="button" type="primary" square size="small" style="width:33%;" :color="GetDiveMainBack()" @click="onClickList">列表</van-button>
          <van-button v-if="questionIndex+1<data.baseData.totalNum" :loading="buttonLoading" class="button" type="primary" square size="small" style="width:33%;" :color="GetDiveMainBack()" @click="onDownQuestion">下一题</van-button>
          <van-button v-if="questionIndex+1>=data.baseData.totalNum" :loading="buttonLoading" class="button" type="primary" square size="small" style="width:33%;" :color="GetDiveMainBack()" @click="onSubject">答题完成</van-button>
        </div>
      <!-- <van-row class="buttons">
        <van-col span="8"><van-button class="button" type="primary" square size="small" style="width:100%;border-top-left-radius: 2em;border-bottom-left-radius:2em;border-top-right-radius: 0;border-bottom-right-radius:0;" :color="GetDiveMainBack()">上一题</van-button></van-col>
        <van-col span="8"><van-button class="button" type="primary" square size="small" style="width:100%;border-radius:0;border-left: 1px solid #f5f5f5; border-right: 1px solid #f5f5f5;" :color="GetDiveMainBack()">列表</van-button></van-col>
        <van-col span="8"><van-button class="button" type="primary" square size="small" style="width:100%;border-top-left-radius: 0;border-bottom-left-radius:0;border-top-right-radius: 2em;border-bottom-right-radius:2em;" :color="GetDiveMainBack()">下一题</van-button></van-col>
      </van-row> -->
      </div>
    </template>
    <van-popup v-model="showList" class="ListRect">
      <div class="title">题目列表</div>
      <div class="QuestionRect">
        <div v-for="(question,index) in data.questionList" :key="question.questionId" class="rect" @click="onSelectQuestion(index)">
          <span :style="checkHaveAnswer(question)?'color:'+GetDiveMainBack():''">{{ index+1 }}</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, RadioGroup, Checkbox, CheckboxGroup, Radio, CountDown, Loading, Tag, Popup, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { getUserBase, MyNotify, getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [CountDown.name]: CountDown,
    [Loading.name]: Loading,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '在线测试',
      backurl: '/divetrip/myExam',
      examStart: false,
      studentId: undefined,
      examId: undefined,
      hashCode: undefined,
      buttonLoading: false,
      data: {
        baseData: undefined,
        questionList: []
      },
      questionData: undefined,
      questionSelect: [],
      questionIndex: 0,
      saveSelectListStr: undefined,
      autoCacheTick: undefined,
      autoSaveing: undefined,
      showList: false,
      formData: {
        selectList: [],
        examResultId: undefined
      },
      selectStudent: undefined
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.autoCacheTick) {
      console.log('释放 autoCacheTick')
      window.clearInterval(this.autoCacheTick)
      this.autoCacheTick = undefined
    }
    next()
  },
  created() {
    getUserBase(data => {
      this.titleTop = GetDiveTitle()
    }, true)

    this.examId = getUrlKey('examId')
    this.hashCode = getUrlKey('hashCode')
    this.studentId = getUrlKey('studentId')
    this.initExamBegin()
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    onSelectStudent() {
      var list = this.data.baseData.examStudentInfo.filter(item => item.studentId === this.studentId)
      if (list.length > 0) {
        this.selectStudent = list[0]
      } else {
        this.selectStudent = null
      }
      console.log('onSelectStudent', this.selectStudent)
    },
    initExamBegin() {
      request({
        url: '/DiveLearn/getExamStart',
        method: 'post',
        data: {
          studentId: this.studentId,
          examId: this.examId,
          hashCode: this.hashCode
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data.baseData = response.data
        if (this.data.baseData.examStudentInfo.length === 1) {
          this.studentId = this.data.baseData.examStudentInfo[0].studentId
          this.selectStudent = this.data.baseData.examStudentInfo[0]
        } else if (this.data.baseData.examStudentInfo.length >= 1) {
          this.studentId = undefined
          this.selectStudent = undefined
        }
      })
    },
    initExam(callback) {
      request({
        url: '/DiveLearn/getExam',
        method: 'post',
        data: {
          studentId: this.studentId,
          examId: this.examId,
          hashCode: this.hashCode
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.data.questionList.forEach(question => {
          if (question.isMultiple) {
            question.select = []
          } else {
            question.select = undefined
          }
        })
        this.data.selectList.forEach(id => {
          this.data.questionList.forEach(question => {
            question.answer.forEach(answer => {
              if (answer.answerId === id) {
                if (question.isMultiple) {
                  question.select.push(id)
                } else {
                  question.select = id
                }
              }
            })
          })
        })
        this.saveSelectListStr = this.getSelectList().join(',')
        this.buttonLoading = false
        if (callback) {
          callback()
        }
      })
    },
    onStart() {
      if (!this.data.baseData.examResultId) {
        if (this.data.baseData.examStudentInfo.length > 1) {
          if (!this.studentId) {
            MyNotify('info', '请选择参与测验的顾客')
            return
          }
        }
      }
      this.buttonLoading = true
      this.initExam(() => {
        this.examStart = true
        this.questionIndex = 0
        this.onLoadQuestion()
        if (this.autoCacheTick) {
          window.clearInterval(this.autoCacheTick)
        }
        console.log('初始化autoCacheTick')
        this.autoCacheTick = setInterval(() => {
          console.log('执行autoCacheTick')
          this.updateExamSelectQuestionList()
        }, 1000 * 60 * 1)
      })
    },
    onUpQuestion() {
      if (this.questionIndex <= 0) {
        return
      }
      this.questionIndex--
      this.onLoadQuestion()
    },
    onDownQuestion() {
      if (this.questionIndex + 1 >= this.data.baseData.totalNum) {
        return
      }
      if (this.questionIndex + 1 >= this.data.questionList.length) {
        return
      }
      this.questionIndex++
      this.onLoadQuestion()
    },
    onLoadQuestion() {
      this.questionSelect = undefined
      this.questionData = this.data.questionList[this.questionIndex]
      this.questionSelect = this.questionData.select
    },
    onSelectQuestion(index) {
      this.showList = false
      this.questionIndex = index
      this.onLoadQuestion()
    },
    onquestionSelectChange() {
      console.log('onquestionSelectChange', this.questionSelect)
      this.questionData.select = this.questionSelect
    },
    getSelectList() {
      var list = []
      this.data.questionList.forEach(question => {
        if (question.isMultiple) {
          if (question.select && question.select.length > 0) {
            list = list.concat(question.select)
          }
        } else {
          if (question.select) {
            list.push(question.select)
          }
        }
      })
      return list
    },
    updateExamSelectQuestionList() {
      var list = this.getSelectList()
      var newStr = list.join(',')
      if (this.saveSelectListStr === newStr) {
        console.log('数据未发生变化，不提交')
        return
      }
      this.saveSelectListStr = newStr
      this.autoSaveing = true
      request({
        url: '/DiveLearn/updateExamSelectQuestionList',
        method: 'post',
        data: {
          examResultId: this.data.baseData.examResultId,
          selectIds: list
        }
      }).then(response => {
        if (!response.success) {
          this.autoSaveing = false
          return
        }
        setTimeout(() => {
          this.autoSaveing = false
        }, 500)
        setTimeout(() => {
          this.autoSaveing = undefined
        }, 1000)
      })
    },
    onClickList() {
      this.showList = true
    },
    checkHaveAnswer(question) {
      if (!question) {
        return false
      }
      if (question.isMultiple) {
        return question.select && question.select.length > 0
      } else {
        if (question.select) {
          return true
        } else {
          return false
        }
      }
    },
    onSubject() {
      Dialog.confirm({
        title: '完成测验',
        message: '是否完成测验，提交卷纸?'
      }).then(() => {
        this.onSubjectDo()
      })
    },
    onSubjectDo() {
      this.buttonLoading = true
      var list = this.getSelectList()
      request({
        url: '/DiveLearn/finishExam',
        method: 'post',
        data: {
          examResultId: this.data.baseData.examResultId,
          selectIds: list
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.$router.push('/divetrip/examFinish/' + response.data.examResultId + '?student=' + this.studentId)
      })
    }
  }
}
</script>
<style>
.questionRect img{
  width: 100%;
}
</style>
<style scoped>
.infoRect{
  background-color: #fff;
  padding: 1em;
  color: #999;
  font-size: 0.9em;
}
.questionRect{
  background-color: #fff;
  padding: 0 1em 1em 1em;
  font-size: 0.9em;
}

.answerRect{
background-color: #fff;
padding:  0 1em;
}
.answerRect .answer{

  font-size: 0.9em;
  padding: 0.5em 0;
  border-bottom: 1px solid #f5f5f5;
}
.answerRect .answer:last-child{
  border-bottom: none;
}
.analysisRect{
  background-color: #fff;
  font-size: 0.9em;
  padding: 1em;
  color: #999;
}
.emptyRect{
  height: 4em;
  }
.buttonRect{
    position: fixed;
    left: 0;
    bottom: 0;
    height: 4em;
    width: 100%;
    border-top: 1px solid #f5f5f5;
    background-color: #fff;

}
.buttonRect .buttons{
    padding: 1em 1em;
}
.buttonRect .button:first-child{
  border-top-left-radius: 2em;
  border-bottom-left-radius: 2em;
}
.buttonRect .button:last-child{
  border-top-right-radius: 2em;
  border-bottom-right-radius: 2em;
}
.buttonRect .button:nth-child(2)
{
  margin: 0 1px;
}
.examStartRect{
  background-color: #fff;
  padding:1em;
}
.examStartRect .title{
  text-align: center;
  font-weight: 700;
  padding-bottom: 0.5em;
}
.examStartRect .about{
  font-size: 0.9em;
  margin: 0.5em 0;
}
.examStartRect .buttons{

}
.buttonMore{
  color: #999;
  font-size: 0.8em;
  text-align: center;
  margin: 0.5em 0;
}
.ListRect{
  width: calc(100vw - 2em);
  background-color: #fff;
  border-radius: 0.4em;
}
.ListRect .title{
  text-align: center;
  padding: 0.3em 0;
  border-bottom: 1px solid #f5f5f5;
}
.ListRect .QuestionRect{
  display: flex;
  flex-wrap: wrap;
  height: 50vh;
  overflow-y: scroll;
}
.ListRect .QuestionRect .rect{
  width: 2em;
  height: 2em;
  border: 1px solid #f5f5f5;
  margin: 0.2em;
  line-height: 2em;
  text-align: center;
}
.ListRect .QuestionRect .select{
  font-weight: 700;
}
.ListRect .QuestionRect .selectAnswer{
  font-weight: 700;
}
.ListRect .QuestionRect .rect span{
font-size: 0.8em;
}
.cantabout{
  color: #999;
  text-align: center;
  font-size: 0.7em;
  margin-top: 0.75em;
}

.selectStudentRect{
  padding-top: 1em;
}
.selectStudentRect .line{
  padding: 0.25em 0 ;
   font-size: 0.7em;
}
</style>
